var exports = {
  "H8": "Cosmetics.module__decoration___VDdJQ2",
  "qF": "Cosmetics.module__nameplate___VDdJQ2",
  "Rt": "Cosmetics.module__nameplateContent___VDdJQ2",
  "QZ": "Cosmetics.module__effect___VDdJQ2",
  "EJ": "Cosmetics.module__effectAlignCenter___VDdJQ2",
  "AG": "Cosmetics.module__effectAlignBottom___VDdJQ2",
  "V2": "Cosmetics.module__frameTop___VDdJQ2",
  "Z2": "Cosmetics.module__frameBottom___VDdJQ2",
  "PG": "Cosmetics.module__frameGlow___VDdJQ2",
};

module.exports = exports;
